export class CoreConstant{

    public static OrganizationStatus = class{

        public static Village = "SK_ORG_VILLAGE";
        public static Dusun = "SK_ORG_DUSUN";

    };

    public static SubOrganizationCategory = class{

        public static Stt = "SK_SUB_ORG_STT";
        public static Shanti = "SK_SUB_ORG_SHANTI";
        public static Gong = "SK_SUB_ORG_GONG";
        public static Pkk = "SK_SUB_ORG_PKK";

    };

    public static PostCategory = class{

        public static Announcement = "SK_POST_ANN";
        public static Agenda = "SK_POST_AGENDA";
        public static News = "SK_POST_NEWS";
        public static About = "SK_POST_ABOUT";
        public static Staff = "SK_POST_STAFF";
        public static Gallery = "SK_POST_GALLERY";

    };

    public static ReportCategory = class{

        public static Report = "SK_REPORT_R";
        public static Aspiration = "SK_REPORT_A";

    };

    public static ReportStatus = class{

        public static New = "SK_RPT_NEW";
        public static OnProcced = "SK_RPT_OP";
        public static Done = "SK_RPT_DONE";

    };

}


// WEBPACK FOOTER //
// ./src/core/utility/CoreConstant.tsx